import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    active: false,
    text: '',
    showMenu: true
};

const preloaderSlice = createSlice({
    name: 'preloader',
    initialState,
    reducers: {
        openPreloader: (state, action) => { 
            state.active = true;
            state.text = action.payload.text ?? initialState.text;
            state.showMenu = action.payload.showMenu ?? initialState.showMenu;
        },
        closePreloader: (state) => { 
            state.active = initialState.active;
            state.text = initialState.text;
            state.showMenu = initialState.showMenu;
        }
    },
});

const { actions, reducer } = preloaderSlice;

export default reducer;

export const {
    openPreloader,
    closePreloader
} = actions;
